import type {
	EnhancedWithTelegramHttpService,
} from '@/shared/lib/services'
import {
	HttpFactoryService,
} from '@/shared/lib/services'
import type {
	ApiResponse,
} from '@/shared/model/types/api/api.types'

import type {
	ICreateUserData,
	IUser,
	IUserStatistics,
} from '../../../model/types'

class UserService {
	private readonly URL = 'users'

	private readonly httpService: EnhancedWithTelegramHttpService

	constructor() {
		this.httpService = new HttpFactoryService().createTelegramHttpService()
	}

	public async create(data: ICreateUserData): Promise<IUser> {
		const response = await this.httpService.post<ApiResponse<IUser>, ICreateUserData>(this.URL, data)

		return response.data
	}

	public async getMe(): Promise<IUser | null> {
		try {
			const response = await this.httpService.get<ApiResponse<IUser>>(`${this.URL}/me`)

			return response.data
		}
		catch {
			return null
		}
	}

	public async getByTelegramId(telegramId: number): Promise<IUser | null> {
		try {
			const response = await this.httpService.get<ApiResponse<IUser>>(`${this.URL}/by-telegram/${String(telegramId)}`)

			return response.data
		}
		catch {
			return null
		}
	}

	public async getOrCreate(telegramUser: {
		first_name?: string
		last_name?:  string
		username?:   string
		id:          number
		photo_url?:  string
	}): Promise<IUser> {
		return this.create({
			telegramId:        telegramUser.id,
			firstName:         telegramUser.first_name,
			lastName:          telegramUser.last_name,
			username:          telegramUser.username,
			telegramAvatarUrl: telegramUser.photo_url,
		})
	}

	public async read(): Promise<unknown> {
		return this.httpService.get(this.URL)
	}

	public async update(data: unknown): Promise<unknown> {
		return this.httpService.patch(this.URL, data)
	}

	public async delete(): Promise<unknown> {
		return this.httpService.delete(this.URL)
	}

	public async getById(userId: string): Promise<IUser | null> {
		try {
			const response = await this.httpService.get<ApiResponse<IUser>>(`${this.URL}/${userId}`)

			return response.data
		}
		catch {
			return null
		}
	}

	public async getStatistics(userId: string): Promise<IUserStatistics | null> {
		try {
			const response = await this.httpService.get<ApiResponse<IUserStatistics>>(`${this.URL}/${userId}/statistics`)

			return response.data
		}
		catch {
			return null
		}
	}
}

export const userService = new UserService()
